<template>
	<div class="bright container-fluid py-2 px-3">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="hasPageChild==0">

			<div class="col-md-12 mb-0">
				<ListItem class=" mb-0" title="TOP 10 PIUTANG" :data="reportdata.data" itemcol="Name" valuecol="SumAmountInDC" 
					textvaluecol="SAM"
					url="/finance/report-group?tab=1"/>
			</div>
			<div v-if="false" class="col-md-12 mb-0 pl-0">
				<ListItemPiutangByAging class="mb-0" title="TOP 10 PIUTANG BY AGING" :data="reportdatapiutangbyaging.data" itemcol="Name" valuecol="SumAmountInDC" 
					textvaluecol="SAM"
					url="/finance/report-group?tab=1"/>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem2.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import ListItemPiutangByAging from '@/views/pages/ListItemPiutangByAging.vue'
import Customer from '@/components/page/Customer.js'
import Footer from '@/views/Footer.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default{
	extends: Customer,
	components:{
		Footer,
		ListItem,
		ListItemPiutangByAging,    
		//Loader,
	},
    mounted(){
		//this.loadTop();
		//this.$store.state.page=window.location.pathname.split('/')[1]===''?'overview':window.location.pathname.split('/')[1];
		//document.title=this.$store.state.page+' - Dashboard'
		this.getData();
		//this.getDataTopPiutangByAging();
    },
	data() {
		return {
			overviewdata: [],
			spbu:{ 
				data:{}, list:[], types:[] 
			},
			loading: {
				table: false,
				overview: false,
			},
			reportdata: [],
			reportdatapiutangbyaging: {
				data: [],
			},

			colortype: ["primary","success","warning","danger"],
		}
	},
	watch: {

	},
    methods:{
		getData() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/customer/top-piutang?'
            
            //this.urlRequestParams+='year='+this.year
            //this.urlRequestParams+='&month='+this.month

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdata = response.data;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },

		getDataTopPiutangByAging() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/customer/top-piutang-by-aging?'
            
            //this.urlRequestParams+='year='+this.year
            //this.urlRequestParams+='&month='+this.month

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdatapiutangbyaging = response.data;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },
	},
}

</script>

<style>
.card {
	border-radius: 6px !important;
	box-shadow: 0 10px 17px 0 rgba(0, 0, 0, 0.04) !important;
}

.card-raised {
    border: none !important;
}

.border-green {
    border-color: #007BFF !important;
}

.widget-title-card {
	font-size: 25px;
}

.border-start-primary {
	border-left: 5px solid #007BFF !important; /** card-raised border-start border-green border-5 */
}

.border-start-success {
	border-left: 5px solid #67C23A !important; /** card-raised border-start border-green border-5 */
}

.border-start-warning {
	border-left: 5px solid #E6A23C !important; /** card-raised border-start border-green border-5 */
}

.border-start-danger {
	border-left: 5px solid #F56C6C !important; /** card-raised border-start border-green border-5 */
}

.widget-icon {
	opacity: .3;
}

.widget-main-title {
	background: #ecf5ff /*#409EFF*/;
	color: #409eff;
	font-size: 20px;
	border-radius: 6px;
	padding: 6px 12px;
	border: 0px solid #b3d8ff;
	font-weight: 600;

	box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.03);
}

</style>